import { QuoteResult } from "../models/QuoteResult";
const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});
const formatterP = new Intl.NumberFormat('en-US', {
    style: 'percent',
    maximumFractionDigits: 2
});
export async function GetQuote(url, quoteRequest) {
    const response = await fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(quoteRequest)
    });
    return response.json();
}
export function SetInputs(inputs, fields) {
    inputs.calculatedBy = fields.calculatedBy;
    inputs.clientName = fields.clientName;
    inputs.gender = fields.gender;
    inputs.investmentAmount = fields.investmentAmount;
    inputs.purchaseAge = fields.purchaseAge;
    inputs.state = fields.state;
    return inputs;
}
export function GetEliResult(response) {
    let eliResults = new QuoteResult();
    eliResults.single = response.SinglePremium;
    eliResults.chronicIllness = response.ChronicAcceleratedBenefit;
    eliResults.guaranteedDeath = response.GuaranteedMinDeathBenefit;
    eliResults.terminalIllness = response.TerminalAcceleratedBenefit;
    return eliResults;
}
export function FormatResult(result) {
    result.guaranteedDeath = formatter.format(parseInt(result.guaranteedDeath));
    result.chronicIllness = formatter.format(parseInt(result.chronicIllness));
    result.terminalIllness = formatter.format(parseInt(result.terminalIllness));
    result.single = formatter.format(parseInt(result.single));
    return result;
}
export function GetValueFromCookies(lead, fields) {
    lead.firstname = fields.firstName;
    lead.lastname = fields.lastName;
    lead.email = fields.email;
    lead.firm = fields.firm;
    lead.zip = fields.zipCode;
    lead.landingpage = window.location.pathname;
    lead.filename = "Hypothetical Illustration";
    lead.campaignid = getParameterByName('campaignid');
    lead.disclosure = fields.authorized;
    lead.resource = getParameterByName('resource');
    lead.source = getParameterByName('source');
    lead.utmcampaign = getParameterByName('utm_campaign');
    lead.utmcontent = getParameterByName('utm_content');
    lead.utmsource = getParameterByName('utm_source');
    lead.utmmedium = getParameterByName('utm_medium');
    lead.utmterm = getParameterByName('utm_term');
    lead.workspaceid = getParameterByName('workspaceid');
}
export function FillLeads(lead, inputs, result, fields) {
    lead.firstname = fields.firstName;
    lead.lastname = fields.lastName;
    lead.email = fields.email;
    lead.firm = fields.firm;
    lead.zip = fields.zipCode;
    lead.landingpage = window.location.pathname;
    lead.filename = "Hypothetical Illustration";
    lead.campaignid = getParameterByName('campaignid');
    lead.disclosure = fields.authorized;
    lead.resource = getParameterByName('resource');
    lead.source = getParameterByName('source');
    lead.utmcampaign = getParameterByName('utm_campaign');
    lead.utmcontent = getParameterByName('utm_content');
    lead.utmsource = getParameterByName('utm_source');
    lead.utmmedium = getParameterByName('utm_medium');
    lead.utmterm = getParameterByName('utm_term');
    lead.workspaceid = getParameterByName('workspaceid');
    return lead;
}
function getParameterByName(name) {
    var url = decodeURIComponent(window.location.href);
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
export function ReadCookie(cname) {
    var name = cname + "=";
    var decoded_cookie = decodeURIComponent(document.cookie);
    var carr = decoded_cookie.split(';');
    for (var i = 0; i < carr.length; i++) {
        var c = carr[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
export async function saveLeadForm(bUrl, lead) {
    const response = await fetch(bUrl, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Origin': '*'
        },
        body: JSON.stringify(lead)
    });
    return response.json();
}
export async function showPdf(bUrl, pdf) {
    setNames(pdf);
    let pdfResponse = await downloadPdf(bUrl, pdf);
    if (pdfResponse.isValid) {
        fetch("data:application/pdf;base64," + pdfResponse.pdf)
            .then(function (resp) { return resp.blob(); })
            .then(function (blob) {
            var pdfFileUrl = window.URL.createObjectURL(blob);
            window.open(pdfFileUrl, '_blank');
        });
    }
}
export async function downloadPdf(bUrl, pdf) {
    let url = bUrl + "EstateMaximizerPdfRequest";
    const response = await fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify(pdf)
    });
    return response.json();
}
export function setNames(pdf) {
    let firstName = "";
    let lastName = "";
    let firm = "";
    let leaddata = ReadCookie("estateMaxModalPDFForm");
    let elements = leaddata.split(',');
    console.log();
    firstName = elements[0].substring(elements[0].indexOf(':') + 2);
    lastName = elements[1].substring(elements[1].indexOf(':') + 2);
    firm = elements[2].substring(elements[1].indexOf(':') + 2);
    pdf.preparedBy = firstName + " " + lastName;
    pdf.firm = firm;
}
